{
	"customSavedCartDetails": {
		"cartName": "Naam",
		"cartDescription": "Omschrijving",
		"cartId": "ID",
		"dateSaved": "Datum opgeslagen",
		"items": "Product",
		"quantity": "Aantal",
		"total": "Totaal",
		"editSavedCart": "Wijzigen",
		"deleteSavedCart": "Verwijderen",
		"addSelectedItems": "Hinzufügen",
		"emptyCartItems": "Empty Cart Items",
		"publicCart": "Winkelwagen openbaar",
		"yes": "Ja",
		"no": "Nee",
		"publicCartFlagUpdated": "Winkelwagen is succesvol bewerkt",
		"publicCartFlagError": "Winkelwagentje kon niet worden bijgewerkt",
		"publicFlagColumn": "privé/openbaar",
		"public": "Openbaar",
		"private": "Privé",
		"active": "Actief"
	},
	"customSavedCartList": {
		"savedCarts": "Opgeslagen winkelwagentjes ({{count}})",
		"cartName": "Naam",
		"cartId": "Id",
		"dateSaved": "Datum opgeslagen",
		"cartDescription": "Omschrijving",
		"quantity": "Aantal",
		"total": "Totaal",
		"actions": "Acties",
		"makeCartActive": "Winkelwagen actief maken",
		"notFound": "Geen opgeslagen winkelwagens gevonden",
		"swapCartNoActiveCart": "Existing cart is activated by {{cartName}} successfully.",
		"swapCartWithActiveCart": "Existing cart is activated by {{cartName}} successfully. Your previous items were saved in a cart {{previousCartName}}."
	},
	"customSavedCartPage": {
		"messages": {
			"cartSaved": "Uw winkelwagenitems zijn met succes opgeslagen voor later in de \"{{cartName}}\" winkelwagen"
		}
	},
	"customSavedCartDialog": {
		"saveForLater": "Opslaan voor later",
		"itemsSavedForLater": "Alle artikelen in uw winkelwagen worden bewaard voor later",
		"Saved Cart Name": "Naam",
		"savedCartDescription": "Omschrijving",
		"optional": "optioneel",
		"charactersLeft": "tekens over: {{count}}",
		"cancel": "Afbreken",
		"save": "Opslaan",
		"followingCartDelete": "Volgende opgeslagen karretjes zullen worden verwijderd",
		"delete": "Verwijderen",
		"deleteCartSuccess": "Winkelwagen succesvol verwijderd",
		"editCartSuccess": "Cart Edited Successfully",
		"editSavedCart": "Edit Saved Cart",
		"deleteSavedCart": "Verwijder Opgeslagen winkelwagen",
		"name": "Naam",
		"id": "ID",
		"description": "Omschrijving",
		"quantity": "Aantal",
		"total": "Totaal",
		"emptyCart": "Deze winkelwagen bevat geen producten"
	},
  "uigAddToSavedCart": {
	"printExport": "Afdrukken/Exporteren",
	"emptyCart": "Winkelwagen leegmaken"
  }
}
